/**
*Created by jmmartinez on 18/03/19
*  v 1.1 08/11/2019 Cambiado nombre de propiedad ServicioUrl por ServicioUploadUrl
 *                  Añadida propiedad fileNameNoDefinido
 *                  Añadida funcionalidad de eliminar.
 *                  Botones activados en función de existencia de imagen.
 * v.2.0  30/09/2020 Cambiado a framework2
 * v.2.1  08/11/2020 Cambiado el render de usar <Container a css con flex.
 *                   Añadidas propiedades título, anchoImagen
 */

import React from 'react'
import PropTypes from 'prop-types';

import {Container, Col, Row} from 'react-grid-system';
import {Button, ProgressBar, Intent, Icon, Dialog} from "@blueprintjs/core";
import FileUploader from "./FileUploader";
import {getFileName} from "../utils/FileUtils";
import "../../resources/css/imagenuploader.css"



class ImagenUploader extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            servicioUploadUrl: props.servicioUploadUrl,
            imagenUrl: props.imagenUrl,
            mostrarUploader: false,
        }
        console.log(props.imagenUrl);
        console.log(getFileName(props.imagenUrl));
    }

    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState) {
        const newState = {};

        if (nextProps.imagenUrl !== prevState.imagenUrl) {
            newState.imagenUrl = nextProps.imagenUrl;
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }

    existeImagen= (imagenUrl) => {
        const {fileNameNoDefinido} = this.props;
        return getFileName(imagenUrl) !== fileNameNoDefinido;
    }

    showUploader= () => {
        const {mostrarUploader} = this.state;
        let newMostrarUploader= !mostrarUploader;
        this.setState({mostrarUploader: newMostrarUploader});
    }

    fileUploaded= (file) => {
        const {onChange} = this.props;
        this.setState({mostrarUploader: false});
        /*
        console.log("IMAGEU - FileUploaded")
        console.log("File:");
        console.log(file.name);
        */
        onChange && onChange(file.name);
    }

    delete= () => {
        const {onChange} = this.props;
        onChange && onChange("");
    }

    render() {
        const {mostrarUploader, imagenUrl} = this.state;
        const {servicioUploadUrl, titulo, anchoImagen} = this.props;
        let conImagen= this.existeImagen(imagenUrl);
        return (
            <>
               <div className="imagenuploader">
                    <div className="imagenuploader_titulo">{titulo}</div>
                    <div className="imagenuploader_contenedor">
                        <div className="imagenuploader_imagen">
                             <img src={imagenUrl} alt="new" style={{width: anchoImagen ? anchoImagen : 100}} />
                        </div>
                        <div className="imagenuploader_botones">
                            <Button icon="cloud-upload" disabled={conImagen} onClick={this.showUploader}/>
                            <Button style={{marginLeft: 10}} icon="trash" disabled={!conImagen} onClick={this.delete}/>
                        </div>
                        <div>
                            {
                                mostrarUploader && <FileUploader url={servicioUploadUrl} onFileUploaded={this.fileUploaded} />
                            }
                        </div>
                    </div>
                </div>
            </>

        )
    }

}


ImagenUploader.propTypes = {
    titulo: PropTypes.string,
    anchoImagen: PropTypes.number,
    servicioUploadUrl: PropTypes.string,
    imagenUrl: PropTypes.string,
    fileNameNoDefinido: PropTypes.string,
}

export default ImagenUploader;